import { BaseStore, getOrCreateStore } from '../../di'
import { action, computed, observable } from 'mobx'
import { curryN, flatten, map, reduce } from 'ramda'

class AddonStore extends BaseStore {
  @observable byHub = observable.map()
  @observable currentHubId = null

  @computed
  get currentAddons() {
    const { currentHubId } = this
    if (currentHubId) {
      const addons = this.getByHub(currentHubId)
      return addons && typeof addons.length === 'number' ? buildHubAddonsInto([], addons) : null
    } else {
      return null
    }
  }

  getByHub = (id) => {
    return this.byHub.get(id) || null
  }

  @action
  load(hubId, json) {
    this.byHub.set(hubId, json)
  }

  @action
  setCurrentHub(hubId) {
    this.currentHubId = hubId
  }

  fetchAddons = async (hubId, jwt, apiUrl, csrfToken) => {
    try {
      const resp = await this.request(
        {
          path: `/hubs/${hubId}/addons`,
        },
        jwt,
        apiUrl,
        csrfToken
      )

      this.load(hubId, resp.data)
      this.setCurrentHub(hubId)
    } catch (e) {
      console.error(e)
    }
  }
}

const buildHubAddonsInto = curryN(2, (xs, ys) =>
  flatten(
    reduce(
      (acc, curr) => {
        if (!curr.configs) {
          return acc
        }
        if (curr.type !== 'legacy') {
          acc.push(map((config) => ({ ...curr, ...config }), curr.configs))
        }
        return acc
      },
      xs,
      ys
    )
  )
)

export default getOrCreateStore('AddonStore', AddonStore)
